// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/TheJamsilThin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/TheJamsilRegular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/TheJamsilBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/MPLUS1p-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/MPLUS1p-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/MPLUS1p-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'TheJamsil';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'TheJamsil';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'TheJamsil';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'MPLUS1p';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'MPLUS1p';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'MPLUS1p';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

* {
  box-sizing: border-box;
  /* color: #ffffff; */
}

.TheJamsil {
  font-family: TheJamsil;
  line-height: 1;
}

.MPlus1 {
  font-family: MPLUS1p;
  letter-spacing: -1px;
  line-height: 1;
}

body {
  font-weight: 400;
  margin: 0;
  min-width: 600px;
  background-color: #121212;
}

h1 {
  font-size: 2.5rem;
  color: #ffffff;
}

h2 {
  font-size: 1.5rem;
  color: #ffffff;
}

:root {
  --main-color: #064f32;
  --main-color-hover: rgb(104, 117, 217, 0.2);
  --track-color: #ddd;
  /* Default mark color*/
  --mark-color: #aaaaaa;
}

.MuiInput-underline:before {
  border-bottom: none !important;
}

.MuiInput-underline:after {
  border-bottom: none !important;
}

.MuiOutlinedInput-adornedEnd {
  padding: 5px !important;
}

.MuiButton-root {
  min-width: 10px !important;
}

.MuiOutlinedInput-inputAdornedEnd {
  color: #9a9a9a !important;
  padding: 18px 5px !important;
}

.MuiAutocomplete-noOptions,
.MuiListSubheader-sticky {
  background-color: #292929 !important;
  color: #9a9a9a !important;
}

.MuiMenu-paper,
.MuiMenuItem-gutters,
.MuiMenu-list {
  background-color: #292929 !important;
  color: #9a9a9a !important;
  border-radius: 8px !important;
  border: none !important;
}

.MuiAutocomplete-listbox {
  background-color: #292929 !important;
  color: #ffffff !important;
}

.MuiAutocomplete-listbox::-webkit-scrollbar {
  width: 12px !important;
}

.MuiAutocomplete-listbox::-webkit-scrollbar-thumb {
  background-color: #888888 !important;
  border-radius: 8px !important;
}

.MuiAutocomplete-listbox::-webkit-scrollbar-thumb:hover {
  background-color: #555 !important;
}

.MuiAutocomplete-input {
  color: '#9a9a9a !important';
}

.MuiAutocomplete-tag {
  color: #ffffff !important;
  background-color: #404040 !important;
  border-radius: 12px !important;
}

.MuiChip-deleteIconFilledColorDefault {
  color: #9a9a9a !important;
  width: 15px !important;
  height: 15px !important;
}

.MuiAutocomplete-root {
  border: 1px solid #404040 !important;
  border-radius: 8px !important;
  background-color: #292929;
}

.MuiSelect-icon,
.MuiSelect-popupIndicator,
.MuiSelect-select,
.MuiAutocomplete-input,
.MuiAutocomplete-clearIndicator,
.MuiAutocomplete-popupIndicator {
  color: #9a9a9a !important;
}

.MuiAutocomplete-input::placeholder {
  color: #9a9a9a !important;
}

.MuiAutocomplete-input {
  color: #9a9a9a !important;
}

.audio-react-recorder__canvas {
  width: 24rem;
  height: 5rem;
  border: 0.1rem solid #262525;
  max-width: 100%;
}

.globalTooltipContainer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 10px;
}

.globalTooltipTextContainer {
  display: flex;
}

.globalTooltipTextLink {
  font-size: 15px;
  font-weight: 500;
  margin: 4px 0;
  line-height: 16px;
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}

.globalTooltipText {
  font-size: 15px;
  font-weight: 300;
  margin: 4px 0;
  color: '#000';
  line-height: 18px;
}

.globalTooltipTextBullet {
  margin-right: 5px;
}

.globalTooltipHeader {
  align-self: center;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 15px;
}

.globalTooltipSubHeaderCenter {
  align-self: center;
  margin-top: 12px;
  margin-bottom: 3px;
  font-size: 15px;
  font-weight: 500;
}

.infinite-scroll-component__outerdiv {
  overflow-y: scroll;
  overflow-x: hidden;
}
@media (max-width: 480px) {
  .infinite-scroll-component__outerdiv {
    padding-bottom: 75px;
  }
}

.infinite-scroll-component__outerdiv::-webkit-scrollbar {
  width: 5px !important;
}

.infinite-scroll-component__outerdiv::-webkit-scrollbar-thumb {
  background-color: rgba(136, 136, 136, 0.1) !important;
  border-radius: 8px !important;
}

.infinite-scroll-component__outerdiv::-webkit-scrollbar-thumb:hover {
  background-color: #555 !important;
}

/* .MuiSelect-select:focus {
  background-color: #fff!important;
} */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;EACxB,+DAAwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAuD;EACvD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;GAEG","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');\n\n@font-face {\n  font-family: 'TheJamsil';\n  src: url('./fonts/TheJamsilThin.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'TheJamsil';\n  src: url('./fonts/TheJamsilRegular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'TheJamsil';\n  src: url('./fonts/TheJamsilBold.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'MPLUS1p';\n  src: url('./fonts/MPLUS1p-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'MPLUS1p';\n  src: url('./fonts/MPLUS1p-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'MPLUS1p';\n  src: url('./fonts/MPLUS1p-Bold.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n* {\n  box-sizing: border-box;\n  /* color: #ffffff; */\n}\n\n.TheJamsil {\n  font-family: TheJamsil;\n  line-height: 1;\n}\n\n.MPlus1 {\n  font-family: MPLUS1p;\n  letter-spacing: -1px;\n  line-height: 1;\n}\n\nbody {\n  font-weight: 400;\n  margin: 0;\n  min-width: 600px;\n  background-color: #121212;\n}\n\nh1 {\n  font-size: 2.5rem;\n  color: #ffffff;\n}\n\nh2 {\n  font-size: 1.5rem;\n  color: #ffffff;\n}\n\n:root {\n  --main-color: #064f32;\n  --main-color-hover: rgb(104, 117, 217, 0.2);\n  --track-color: #ddd;\n  /* Default mark color*/\n  --mark-color: #aaaaaa;\n}\n\n.MuiInput-underline:before {\n  border-bottom: none !important;\n}\n\n.MuiInput-underline:after {\n  border-bottom: none !important;\n}\n\n.MuiOutlinedInput-adornedEnd {\n  padding: 5px !important;\n}\n\n.MuiButton-root {\n  min-width: 10px !important;\n}\n\n.MuiOutlinedInput-inputAdornedEnd {\n  color: #9a9a9a !important;\n  padding: 18px 5px !important;\n}\n\n.MuiAutocomplete-noOptions,\n.MuiListSubheader-sticky {\n  background-color: #292929 !important;\n  color: #9a9a9a !important;\n}\n\n.MuiMenu-paper,\n.MuiMenuItem-gutters,\n.MuiMenu-list {\n  background-color: #292929 !important;\n  color: #9a9a9a !important;\n  border-radius: 8px !important;\n  border: none !important;\n}\n\n.MuiAutocomplete-listbox {\n  background-color: #292929 !important;\n  color: #ffffff !important;\n}\n\n.MuiAutocomplete-listbox::-webkit-scrollbar {\n  width: 12px !important;\n}\n\n.MuiAutocomplete-listbox::-webkit-scrollbar-thumb {\n  background-color: #888888 !important;\n  border-radius: 8px !important;\n}\n\n.MuiAutocomplete-listbox::-webkit-scrollbar-thumb:hover {\n  background-color: #555 !important;\n}\n\n.MuiAutocomplete-input {\n  color: '#9a9a9a !important';\n}\n\n.MuiAutocomplete-tag {\n  color: #ffffff !important;\n  background-color: #404040 !important;\n  border-radius: 12px !important;\n}\n\n.MuiChip-deleteIconFilledColorDefault {\n  color: #9a9a9a !important;\n  width: 15px !important;\n  height: 15px !important;\n}\n\n.MuiAutocomplete-root {\n  border: 1px solid #404040 !important;\n  border-radius: 8px !important;\n  background-color: #292929;\n}\n\n.MuiSelect-icon,\n.MuiSelect-popupIndicator,\n.MuiSelect-select,\n.MuiAutocomplete-input,\n.MuiAutocomplete-clearIndicator,\n.MuiAutocomplete-popupIndicator {\n  color: #9a9a9a !important;\n}\n\n.MuiAutocomplete-input::placeholder {\n  color: #9a9a9a !important;\n}\n\n.MuiAutocomplete-input {\n  color: #9a9a9a !important;\n}\n\n.audio-react-recorder__canvas {\n  width: 24rem;\n  height: 5rem;\n  border: 0.1rem solid #262525;\n  max-width: 100%;\n}\n\n.globalTooltipContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 10px;\n}\n\n.globalTooltipTextContainer {\n  display: flex;\n}\n\n.globalTooltipTextLink {\n  font-size: 15px;\n  font-weight: 500;\n  margin: 4px 0;\n  line-height: 16px;\n  color: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.globalTooltipText {\n  font-size: 15px;\n  font-weight: 300;\n  margin: 4px 0;\n  color: '#000';\n  line-height: 18px;\n}\n\n.globalTooltipTextBullet {\n  margin-right: 5px;\n}\n\n.globalTooltipHeader {\n  align-self: center;\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 15px;\n}\n\n.globalTooltipSubHeaderCenter {\n  align-self: center;\n  margin-top: 12px;\n  margin-bottom: 3px;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.infinite-scroll-component__outerdiv {\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n@media (max-width: 480px) {\n  .infinite-scroll-component__outerdiv {\n    padding-bottom: 75px;\n  }\n}\n\n.infinite-scroll-component__outerdiv::-webkit-scrollbar {\n  width: 5px !important;\n}\n\n.infinite-scroll-component__outerdiv::-webkit-scrollbar-thumb {\n  background-color: rgba(136, 136, 136, 0.1) !important;\n  border-radius: 8px !important;\n}\n\n.infinite-scroll-component__outerdiv::-webkit-scrollbar-thumb:hover {\n  background-color: #555 !important;\n}\n\n/* .MuiSelect-select:focus {\n  background-color: #fff!important;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
